<template>
  <!--CUSTOM FIX FOR ACTION AND DECISION ITEMS BECAUSE WE ALLOW VIEW AND CREATE THEM IF THE USER HAS ACCESS TO THE PARENT ACTION AND DECISION MODEL-->
  <v-expansion-panel v-if="relation_page.name === 'actionanddecisionitems' || showPanel" elevation="0">
    <v-expansion-panel-title v-if="show_title">
      <v-toolbar flat color="white" density="compact" style="width:98%">
        <template v-if="$icons[relation_page.name]">
          <component v-if="$icons[relation_page.name].includes('Ph')" :is="$icons[relation_page.name]" size="24"/>
          <v-icon v-else class="mr-2" :icon="$icons[relation_page.name]"/>
        </template>
        <v-toolbar-title v-if="label">{{ $store.getters.translate(label) }}<small class="ml-1">({{ getRecords.length }})</small></v-toolbar-title>
        <v-toolbar-title v-else>{{ $store.getters.translate(relation_page.name) }}<small class="ml-1">({{ getRecords.length }})</small></v-toolbar-title>
      </v-toolbar>
    </v-expansion-panel-title>
    <v-expansion-panel-text>
      <v-toolbar flat color="white" density="compact">
        <!--RESPONSIBLE EMPLOYEE AND STATUS DROPDOWNS (USED IN ACTION AND DECISION ITEMS ONLY)-->
        <template v-if="relation_page.name === 'actionanddecisionitems'">
          <v-autocomplete
              class="reg-normal text-primary ml-5"
              base-color="border-tertiary"
              bg-color="secondary"
              density="compact"
              v-model="advanced_search.responsible_employee_name"
              :items="advanced_search_models.responsible_employee_name"
              @update:model-value="showRecords"
              :return-object="false"
              hide-details
              single-line
              clearable>
            <template #label>
              <span class="sm-normal text-subtle">{{ $store.getters.translate('responsible_employee_name') }}</span>
            </template>
          </v-autocomplete>
          <v-autocomplete
              class="reg-normal text-primary ml-5"
              base-color="border-tertiary"
              bg-color="secondary"
              density="compact"
              v-model="advanced_search.responsible_employee_company"
              :items="advanced_search_models.responsible_employee_company"
              @update:model-value="showRecords"
              :return-object="false"
              hide-details
              single-line
              clearable>
            <template #label>
              <span class="sm-normal text-subtle">{{ $store.getters.translate('company') }}</span>
            </template>
          </v-autocomplete>
          <v-autocomplete
              class="reg-normal text-primary ml-5"
              base-color="border-tertiary"
              bg-color="secondary"
              density="compact"
              v-model="advanced_search.action_and_decision_item_status"
              :items="advanced_search_models.action_and_decision_item_status"
              @update:model-value="showRecords"
              :return-object="false"
              hide-details
              single-line
              clearable>
            <template #label>
              <span class="sm-normal text-subtle">{{ $store.getters.translate('action_and_decision_item_status') }}</span>
            </template>
          </v-autocomplete>
        </template>
        <v-spacer/>
        <div class="chip-container">
          <!--PUNCHLIST ITEMS EXPORT-->
          <template v-if="relation_page.name === 'punchlistitems'">
            <base-action-button @action="$emit('exportPunchlistToPdf');">
              <template #prepend><PhFilePdf style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
              {{ $store.getters.translate("export_to_pdf") }}
            </base-action-button>
            <base-action-button @action="$emit('exportPunchlistToExcel');">
              <template #prepend><PhFileXls style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
              {{ $store.getters.translate("export_to_excel") }}
            </base-action-button>
          </template>
          <!--EXCEL EXPORT-->
          <base-action-button v-else-if="getRecords.length > 0">
            <template #prepend><PhFileXls style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
            <template #default>
              <download-excel :data="getRecordsForExport" :name="page.name + '.xls'">
                {{ $store.getters.translate('export_to_excel') }}
              </download-excel>
            </template>
          </base-action-button>
          <!--LINK-->
          <base-action-button v-if="base_table_includable_options.link && selected.length === 0 && canEditBaseModel" @action="link()">
            <template #prepend><PhLink style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
            {{ $store.getters.translate('link') + ' ' + $store.getters.translate(relation_page.name) }}
          </base-action-button>
          <!--CREATE-->
          <!--CUSTOM FIX FOR ACTION AND DECISION ITEMS BECAUSE WE ALLOW CREATE THEM IF THE USER HAS ACCESS TO THE PARENT ACTION AND DECISION MODEL-->
          <base-action-button v-if="base_table_includable_options.create && (relation_page.name === 'actionanddecisionitems' || canCreateRelatedModel)" @action="$emit('create');">
            <template #prepend><PhPlus style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
            {{ $store.getters.translate("create") }}
          </base-action-button>
          <!--FILTER-->
          <base-action-button @action="$emit('showFieldsSettings', relation_page.model);">
            <template #prepend><PhSlidersHorizontal style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
            {{ $store.getters.translate("fields") }}
          </base-action-button>
        </div>
        <v-menu v-if="relation_page.name === 'punchlistitems' || relation_page.name === 'defects'">
          <template #activator="{ props }">
            <v-btn elevation="0" icon v-bind="props">
              <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-if="getClosedState" @click="setClosedState(false)">
              <template #prepend><PhEye size="24"/></template>
              <v-list-item-title class="sm-normal link ml-2">
                <span>{{ $store.getters.translate('show_closed') }}</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-else @click="setClosedState(true)">
              <template #prepend><PhEyeSlash size="24"/></template>
              <v-list-item-title class="sm-normal link ml-2">
                <span>{{ $store.getters.translate('hide_closed') }}</span>
              </v-list-item-title>
            </v-list-item>
            <template v-if="relation_page.name === 'punchlistitems'">
              <v-list-item v-if="getInactiveState" @click="setInactiveState(false)">
                <template #prepend><PhEye size="24"/></template>
                <v-list-item-title class="sm-normal link ml-2">
                  <span>{{ $store.getters.translate('show_inactive') }}</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-else @click="setInactiveState(true)">
                <template #prepend><PhEyeSlash size="24"/></template>
                <v-list-item-title class="sm-normal link ml-2">
                  <span>{{ $store.getters.translate('hide_inactive') }}</span>
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
        <div v-else style="margin-right: 16px;"/>
      </v-toolbar>
      <div style="overflow-x: auto; width: 100%;">
        <v-data-table
            :headers="fields"
            :items="getRecords"
            item-value="id"
            selectable-key="id"
            return-object
            :show-select="!base_table_includable_options.no_select"
            v-model="selected"
            v-bind="footer_props"
            v-model:items-per-page="options.itemsPerPage"
            v-model:page="options.page"
            v-model:sort-by="options.sortBy"
            @update:current-items="current = $event">
          <!--CUSTOM SELECT-ALL WITH DROPDOWN-->
          <template #header.data-table-select>
            <v-chip variant="outlined" class="bulk-chip" rounded="pill" size="large" density="comfortable">
              <v-menu :disabled="selected.length === 0">
                <template #activator="{ props: menuProps, isActive }">
                  <div class="chip-content">
                    <v-checkbox
                        :model-value="selected.length > 0 && selected.length === getRecords.length"
                        :indeterminate="selected.length > 0 && selected.length < getRecords.length"
                        @click="toggleSelectAll"
                        color="success"
                        hide-details/>
                    <v-btn v-bind="menuProps" v-if="selected.length" icon class="arrow-btn" elevation="0">
                      <PhCaretUp v-if="isActive" size="20"/>
                      <phCaretDown v-else size="20"/>
                    </v-btn>
                  </div>
                </template>
                <v-list v-if="selected.length > 0 && (relation_page.name === 'documents' || (base_table_includable_options.detachable && canEditBaseModel) || (!base_table_includable_options.detachable && canDeleteRelatedModel))">
                  <!--DETACH-->
                  <v-list-item v-if="base_table_includable_options.detachable && canEditBaseModel" @click.stop="bulkArchiveOrDetach">
                    <template #prepend><PhLinkBreak size="24"/></template>
                    <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate("detach") + ' ' + selected.length + ' ' + $store.getters.translate(relation_page.name) }}</v-list-item-title>
                  </v-list-item>
                  <!--DELETE-->
                  <v-list-item v-if="!base_table_includable_options.detachable && canDeleteRelatedModel" @click.stop="bulkArchiveOrDetach">
                    <template #prepend><PhTrash size="24"/></template>
                    <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate("delete") + ' ' + selected.length + ' ' + $store.getters.translate(relation_page.name) }}</v-list-item-title>
                  </v-list-item>
                  <!--DOWNLOAD DOCUMENTS-->
                  <v-list-item v-if="relation_page.name === 'documents'" @click.stop="$emit('download', selected);">
                    <template #prepend><PhDownloadSimple size="24"/></template>
                    <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate("download") + ' ' + selected.length + ' ' + $store.getters.translate(relation_page.name) }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-chip>
          </template>
          <!--CUSTOM DESCRIPTION HEADER WITH GOLD V-CHIP-->
          <!--    <template #header.description="{ column }">
                    <v-chip size="small" rounded="lg" color="yellow" class="text-primary sm-bold" variant="elevated">{{ column.title }} </v-chip>
                  </template>-->
          <template #body.prepend>
            <tr>
              <td v-if="!base_table_includable_options.no_select"/><!--EMPTY TD FOR CHECKBOXES-->
              <td v-for="(key, index) in Object.keys(response_fields)" :key="index">
                <base-field-in-table-header :advanced_search="advanced_search" :field_name="key" :field_type="response_fields[key]" :page_name="relation_page.name" @showRecords="showRecords" @clearSearch="clearSearch"/>
              </td>
              <td v-if="(base_table_includable_options.copy && canCreateRelatedModel) || canEditRelatedModel" style="width: 80px;"/><!--EMPTY TD FOR ACTIONS-->
            </tr>
          </template>
          <template #body="{ items }">
            <tr :class="getRowClass(item)" v-for="item in items" :key="item.id" class="sm-normal text-primary" @click.ctrl="handleCtrlClick(item)">
              <td v-if="!base_table_includable_options.no_select">
                <v-checkbox color="success" density="compact" v-model="selected" :key="item.id" :value="item" @click.shift="handleShiftClick(item)"/>
              </td>
              <td v-for="(key, index) in Object.keys(response_fields)" :key="index" @click.exact="$emit('edit', item, relation_page.name)">
                <base-field-in-table :item="item" :field_name="key" :field_type="response_fields[key]" :page_name="relation_page.name"/>
              </td>
              <!--ACTION BUTTONS-->
              <td style="text-align: center; width: 80px;" v-if="(base_table_includable_options.copy && canCreateRelatedModel) || canEditRelatedModel">
                <v-menu>
                  <template #activator="{ props }">
                    <v-btn elevation="0" :class="getRowClass(item)" icon v-bind="props">
                      <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-if="base_table_includable_options.copy && canCreateRelatedModel" @click="makeCopy(item)">
                      <template #prepend><PhCopySimple size="24"/></template>
                      <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('copy') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="canEditRelatedModel" @click="$emit('edit', item, relation_page.name)">
                      <template #prepend><PhPencilSimpleLine size="24"/></template>
                      <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('edit') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
            <tr v-if="getRecords.length === 0">
              <td :colspan="fields.length + 1" class="text-center">
                <span class="sm-normal link">{{ $store.getters.translate("nothing_found") }}</span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <base-link ref="base_link" :relation_page="relation_page" :excluded_ids="$lodash.map(getRecords, 'id')" @refresh="$emit('refresh')" @linkOrCreateRecord="linkOrCreateRecord"/>
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>

<script>
import { useAbility } from '@casl/vue';
import helpFunctions from "../../plugins/helpFunctions.js";
import BaseLink from "./BaseLink";
import BaseActionButton from "./BaseActionButton";
import BaseFieldInTable from "./BaseFieldInTable";
import BaseFieldInTableHeader from "./BaseFieldInTableHeader";
import {
  PhLink,
  PhLinkBreak,
  PhDownloadSimple,
  PhPlus,
  PhSlidersHorizontal,
  PhCaretUp,
  PhCaretDown,
  PhDotsThreeVertical,
  PhCopySimple,
  PhPencilSimpleLine,
  PhTrash,
  PhFilePdf,
  PhFileXls,
  PhEye,
  PhEyeSlash,
  PhFireExtinguisher,
  PhLayout,
  PhAddressBook,
  PhCalendarCheck,
  PhFolders,
  PhClipboard,
  PhListChecks,
  PhUserSwitch
} from '@phosphor-icons/vue';
import moment from "moment/moment";

export default {
  components: {
    BaseLink,
    BaseActionButton,
    BaseFieldInTable,
    BaseFieldInTableHeader,
    PhFireExtinguisher, PhLayout, PhAddressBook, PhCalendarCheck, PhFolders, PhClipboard, PhListChecks, PhUserSwitch, PhEyeSlash, PhEye, PhFilePdf, PhTrash, PhFileXls, PhLink, PhLinkBreak, PhDownloadSimple, PhPlus, PhSlidersHorizontal, PhCaretUp, PhCaretDown, PhDotsThreeVertical, PhCopySimple, PhPencilSimpleLine
  },
  setup() {
    const { can } = new useAbility();
    return { can }
  },
  props: ["page", "parent_module_id", "top_level_module_type", "top_level_module_id", "relation_name", "label", "internal_model", "show_title"],
  data() {
    return {
      relation_page: null,
      selected: [],
      all_records: [],
      records: [],
      options: {},
      footer_props: helpFunctions.footer_props,
      base_table_includable_options: {},
      advanced_search: {
        responsible_employee_name: null,
        responsible_employee_company: null,
        action_and_decision_item_status: null,
        tags: [],
      },
      //ACTION AND DECISION ITEMS FILTER VARIABLES
      advanced_search_models: {
        responsible_employee_name: [],
        responsible_employee_company: [],
        action_and_decision_item_status: [],
      },
      response_fields: [],
      fields: [],
      current: [],
      export_fields: {},
    };
  },
  created() {
    this.relation_page = helpFunctions.pages[this.relation_name];
    if(helpFunctions.getLocalStorageValue(this.relation_page.name + "_includable_options")) {
      this.options = helpFunctions.getLocalStorageValue(this.relation_page.name + "_includable_options");
    }
    else {
      this.options = helpFunctions.table_options;
    }
    this.base_table_includable_options = helpFunctions.base_table_includable_options[this.page.name][this.relation_page.name];

    /*if(localStorage.getItem(this.relation_page.name + "_last_visited_id")) {
      let last_visited_id = localStorage.getItem(this.relation_page.name + "_last_visited_id");
      if(last_visited_id === this.$route.params.id && helpFunctions.getLocalStorageValue(this.relation_page.name + "_includable_advanced_search")) {
        this.advanced_search = helpFunctions.getLocalStorageValue(this.relation_page.name + "_includable_advanced_search");
      }
    }
    localStorage.setItem(this.relation_page.name + "_last_visited_id", this.$route.params.id);*/

    this.getFields();
    this.getFieldsForExport();
  },
  methods: {
    toggleSelectAll() {
      const currentValues = this.current.map(item => item.value);
      const allSelected = currentValues.every(cv =>
          this.selected.some(sel => sel.id === cv.id)
      );

      if (allSelected) {
        this.selected = this.selected.filter(item =>
            !currentValues.some(cv => cv.id === item.id)
        );
      } else {
        const selectedIds = new Set(this.selected.map(item => item.id));
        const toAdd = currentValues.filter(cv => !selectedIds.has(cv.id));
        this.selected = [...this.selected, ...toAdd];
      }
    },
    async bulkArchiveOrDetach() {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          let result = {
            model_id: this.parent_module_id,
            relation_name: this.relation_page.name,
            model_to_delete: this.relation_page.model,
            ids: this.$lodash.map(this.selected, "id"),
            model: this.page.model === 'employee' && (this.relation_page.name === 'roles' || this.relation_page.name === 'tokens') ? 'User' : this.page.model,
          };
          await helpFunctions.postCustomRoute(this.$toast, "bulk/remove", result, true, true);
          this.selected = [];
          this.$emit('update');
        }
      });
    },
    async linkOrCreateRecord(objects) {
      let result = {
        model_id: this.parent_module_id,
        relation_name: this.relation_page.name,
        ids: this.$lodash.map(objects, "id"),
        objects: objects,
        model: this.page.model === 'employee' && (this.relation_page.name === 'roles' || this.relation_page.name === 'tokens') ? 'User' : this.page.model,
      };
      await helpFunctions.postCustomRoute(this.$toast, "bulk/attach", result, true, true);
      this.$emit('update');
    },
    link() {
      this.$refs.base_link.load();
    },
    async makeCopy(item) {
      this.$confirm(this.$store.getters.translate("are_you_sure")).then(async (res) => {
        if (res) {
          item.model = this.relation_page.model;
          await helpFunctions.postCustomRoute(this.$toast, "bulk/copy", item, true, true);
          this.selected = [];
          this.$emit('update');
        }
      });
    },
    fillAdvancedSearchArrays() {
      this.all_records.forEach(record => {
        if(record.responsible_employee_name && !this.advanced_search_models.responsible_employee_name.includes(record.responsible_employee_name)) {
          this.advanced_search_models.responsible_employee_name.push(record.responsible_employee_name);
        }
        if(record.responsible_employee_company && !this.advanced_search_models.responsible_employee_company.includes(record.responsible_employee_company)) {
          this.advanced_search_models.responsible_employee_company.push(record.responsible_employee_company);
        }
        if(record.action_and_decision_item_status && !this.advanced_search_models.action_and_decision_item_status.includes(record.action_and_decision_item_status)) {
          this.advanced_search_models.action_and_decision_item_status.push(record.action_and_decision_item_status);
        }
      });
    },
    showRecords() {
      let sorted_array = this.all_records;
      if(this.relation_page.name === "actionanddecisionitems") {
        if(this.advanced_search.responsible_employee_name) {
          sorted_array = sorted_array.filter(item => item.responsible_employee_name === this.advanced_search.responsible_employee_name);
        }
        if(this.advanced_search.responsible_employee_company) {
          sorted_array = sorted_array.filter(item => item.responsible_employee_company === this.advanced_search.responsible_employee_company);
        }
        if(this.advanced_search.action_and_decision_item_status) {
          sorted_array = sorted_array.filter(item => item.action_and_decision_item_status === this.advanced_search.action_and_decision_item_status);
        }
      }
      this.records = helpFunctions.showRecords(sorted_array, this.response_fields, this.advanced_search, this.relation_page.name);
    },
    clearSearch(key) {
      this.advanced_search[key] = null;
      this.showRecords();
    },
    handleCtrlClick(item) {
      if(this.selected.find((el) => el.id === item.id)) {
        this.selected = this.selected.filter((el) => el.id !== item.id);
      }
      else {
        this.selected.push(item);
      }

    },
    handleShiftClick(item) {
      if (this.selected.length === 1 || this.selected.length === 2) {
        const IDs = [this.selected[1]?.id ?? item.id, this.selected[0].id]    // @click.shift is triggered before v-model="selected" updates, so we need to form a list of IDs from the item.
        let start = this.current.findIndex(el => el.raw.id === Math.min(...IDs));       // getting the starting element index
        let end = this.current.findIndex(el => el.raw.id === Math.max(...IDs));       //  end element index
        if(start > end) {
          let tmp = end;
          end = start;
          start = tmp;
        }
        for (let i = start; i < end; i++) {
          if (!this.selected.find((el) => el.id === this.current[i].key)) {
            this.selected.push(this.current[i].raw);
          }
        }
      }
    },
    getRowClass(item) {
      if(item.action_and_decision_item_status !== 'Closed' && item.action_and_decision_item_status !== 'Cancelled' && item.target_completion_date) {
        let parsedDate = moment(item.target_completion_date, 'DD-MM-YYYY');
        if(parsedDate.isValid() && parsedDate.isBefore(moment())) {
          return 'lightpink-bg';
        }
      }
      return 'white-bg';
    },
    async getFields() {
      let response = await helpFunctions.getCustomRoute(this.$toast, "fields?show_in_search=true&model_type=" + this.relation_page.model);
      this.fields = [];
      this.response_fields = [];
      response.forEach((item) => {
        this.response_fields[item.name] = item.field_type;
      });
      this.response_fields = helpFunctions.replaceIDwithNameBaseTable(this.response_fields);
      let add_actions_column = (this.base_table_includable_options.copy && this.canCreateRelatedModel) || this.canEditRelatedModel;
      this.fields = helpFunctions.composeFields(this.response_fields, add_actions_column);
    },
    async getFieldsForExport() {
      let response = await helpFunctions.getCustomRoute(this.$toast, "fields?model_type=" + this.relation_page.model);
      this.export_fields = [];
      response.forEach((item) => {
        item.name = helpFunctions.replaceIDwithNameBaseTableInc(item.name);
        this.export_fields[this.$store.getters.translate(item.name)] = item.name;
      });
    },
    setClosedState(new_state) {
      if(this.relation_page.name === 'punchlistitems') {
        this.options.hide_closed_punchlistitems = new_state;
      }
      else if(this.relation_page.name === 'defects') {
        this.options.hide_closed_defects = new_state;
      }
    },
    setInactiveState(new_state) {
      if(this.relation_page.name === 'punchlistitems') {
        this.options.hide_inactive_punchlistitems = new_state;
      }
    },
  },
  computed: {
    getClosedState() {
      if(this.relation_page.name === 'punchlistitems') {
        return this.options.hide_closed_punchlistitems;
      }
      else if(this.relation_page.name === 'defects') {
        return this.options.hide_closed_defects;
      }
    },
    getInactiveState() {
      if(this.relation_page.name === 'punchlistitems') {
        return this.options.hide_inactive_punchlistitems;
      }
    },
    getRecords() {
      if(this.relation_page.name === 'punchlistitems') {
        if(this.options.hide_inactive_punchlistitems && this.options.hide_closed_punchlistitems) {
          return this.records.filter((record) => record.active && !record.status);
        }
        else if(this.options.hide_inactive_punchlistitems) {
          return this.records.filter((record) => record.active);
        }
        else if(this.options.hide_closed_punchlistitems) {
          return this.records.filter((record) => !record.status);
        }
        else {
          return this.records;
        }
      }
      else if(this.relation_page.name === 'defects' && this.options.hide_closed_defects) {
        return this.records.filter((record) => record.opened);
      }
      else if(this.records) {
        return this.records;
      }
      else {
        return [];
      }
    },
    getRecordsForExport() {
      let results = this.$lodash.cloneDeep(this.records);
      results.forEach((item) => {
        Object.entries(item).forEach(([key, value]) => {
          if(key === 'distribution_device_function_name' || key === 'deficiency_group') {
            item[key] = this.$store.getters.translate(value);
          }
          else if(key === 'defect_locations' && item[key] && item[key].length > 0) {
            let defect_locations = [];
            item[key].forEach((defect_location) => {
              defect_locations.push(this.$store.getters.translate(defect_location));
            });
            item[key] = defect_locations;
          }
        });
      });
      return results;
    },
    canEditBaseModel() {
      return this.can("edit", this.$createEntity(this.page.model.toLowerCase(), { id: 0 })) ||
          this.can("edit", this.$createEntity(this.page.model.toLowerCase(), { id: this.parent_module_id }));
    },
    canCreateRelatedModel() {
      return this.internal_model || this.can("create", this.$createEntity(this.relation_page.model, { id: 0 }));
    },
    canDeleteRelatedModel() {
      return this.internal_model || this.can("delete", this.$createEntity(this.relation_page.model, { id: 0 }));
    },
    canEditRelatedModel() {
      return this.internal_model || this.can("edit", this.$createEntity(this.relation_page.model, { id: 0 }));
    },
    showPanel() {
      return this.internal_model || this.can("show", this.$createEntity(this.relation_page.model, { id: 0 })) ||
          //IF THE USER HAS CUSTOM PERMISSION FOR PARENT RECORD WE ALLOW HIM TO VIEW IT`S ITEMS
          (this.parent_module_id && this.can("show", this.$createEntity(this.page.model.toLowerCase(), { id: this.parent_module_id }))) ||
          //IF THE USER HAS CUSTOM PERMISSION FOR PARENT INSPECTION WE ALLOW HIM TO DO THE SAME WITH IT`S ARTICLES, ARTICLE ITEMS AND DEFECTS
          //THE CONDITION IS USED ONLY FOR DEFECTS AT "INSPECTION/EDIT" PAGE, ARTICLES AND DEFECTS AT "INSPECTION ITEM/EDIT" PAGE, ARTICLE ITEMS AT "ARTICLE/EDIT" PAGE
          (this.top_level_module_type && this.top_level_module_id && this.can("show", this.$createEntity(this.top_level_module_type, { id: this.top_level_module_id })));
    },
  },
  watch: {
    options: {
      handler() {
        this.selected = [];
        helpFunctions.setLocalStorageValue(this.relation_page.name + "_includable_options", this.options);
      },
      deep: true,
    },
    advanced_search: {
      handler() {
        helpFunctions.setLocalStorageValue(this.relation_page.name + "_includable_advanced_search", this.advanced_search);
        this.options.page = 1;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.v-checkbox {
  display: flex;
}

.bulk-chip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-color: rgba(var(--v-theme-primary), 0.3);
  padding: 0px !important;
}

.chip-content {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

.arrow-btn {
  width: 36px;
  height: 36px;
  min-width: 0;
  background-color: transparent;
}

.chip-container {
  display: flex;
  gap: 8px;
}

.v-text-field >>> input {
  font-size: 12px !important;
}
.v-text-field >>> label {
  font-size: 12px !important;
}
/*FIX GREY BACKGROUND COLOR WHEN HOVERING OVER V-EXPANSION-PANEL-TITLE.*/
.v-expansion-panel {
  .v-expansion-panel-title:hover {
    color: transparent;
  }
}

.white-bg {
  background-color: white;
}
.lightpink-bg {
  background-color: lightpink;
}
</style> 